import React from 'react'
import Loadable from 'Components/LoadableToImported'

const loading = () => <div />

export const ImageSlider = Loadable({
  loader: () => import(/* webpackChunkName: "ImageSlider" */ './ImageSlider'),
  loading,
  chunkName: 'ImageSlider',
})

export { default as Locked } from './Locked'
export { default as Unlocked } from './Unlocked'
export { default as ImgPreview } from './ImgPreview'
export { default as AddressHolder } from './AddressHolder'
export { default as InfoHolderLocked } from './InfoHolderLocked'
export { default as CardFooter } from './CardFooter'
export { default as LinkWrapper } from './LinkWrapper'
